// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GZwcJSPkZS {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.GZwcJSPkZS h4 {
  line-height: 3em;
}
.GZwcJSPkZS .F8cMSZaC7p {
  float: left;
  width: 100%;
}
.GZwcJSPkZS .ZykFZhx0BG {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.GZwcJSPkZS .ZykFZhx0BG:hover {
  cursor: pointer;
}
.GZwcJSPkZS .ZykFZhx0BG:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.hybQZy90Wv .rGbWH2fthO:focus {
  outline: none;
}
.hybQZy90Wv .rGbWH2fthO.DP7dv9E_vW.bB7hFy_HVF {
  background: #375A88;
}
.hybQZy90Wv .rGbWH2fthO.DP7dv9E_vW.bB7hFy_HVF span {
  color: #fff;
}
.hybQZy90Wv .bB7hFy_HVF {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.hybQZy90Wv .bB7hFy_HVF:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.hybQZy90Wv input {
  height: 38px;
  min-width: 220px;
}
.ZykFZhx0BG.SCCsst51cE {
  background: #410102;
}
.ZykFZhx0BG.ByPutRaigN {
  background: #911318;
}
.ZykFZhx0BG.dATjqRTqTQ {
  background: #D8293B;
}
.ZykFZhx0BG.o5XF8xZfrb {
  background: #F2373C;
}
.ZykFZhx0BG.TLQ2LrOHDd {
  background: #FC4448;
}
.ZykFZhx0BG._HZvGH1XXG {
  background: #ED535E;
}
.ZykFZhx0BG.iCHRQUasnb {
  background: #E34926;
}
.ZykFZhx0BG.nyZho1lqBK {
  background: #FC562B;
}
.ZykFZhx0BG.B4XI3q4ceL {
  background: #FC6722;
}
.ZykFZhx0BG.znOpVld2xF {
  background: #FD7F24;
}
.ZykFZhx0BG.Tswy3wC_e3 {
  background: #FD8D26;
}
.ZykFZhx0BG.bSrji2HybU {
  background: #EC9C3E;
}
.ZykFZhx0BG.W6CFYNxqlG {
  background: #0e673a;
}
.ZykFZhx0BG.GlVawwCAp2 {
  background: #208740;
}
.ZykFZhx0BG.cfa2aajBqR {
  background: #239718;
}
.ZykFZhx0BG.cBMs2VEJWr {
  background: #55A84D;
}
.ZykFZhx0BG.IIeGOvNzin {
  background: #4BBE5A;
}
.ZykFZhx0BG.qFmvWjx6WX {
  background: #0CCA6A;
}
.ZykFZhx0BG.mxxP_gI5Tc {
  background: #0A3C64;
}
.ZykFZhx0BG.RMTMgWc9uD {
  background: #0d487a;
}
.ZykFZhx0BG.lSt6QqbkE_ {
  background: #10538d;
}
.ZykFZhx0BG.pB7QaRs0Wk {
  background: #115A99;
}
.ZykFZhx0BG.R5pCYCZMBN {
  background: #3387E2;
}
.ZykFZhx0BG.a3POoOlBJU {
  background: #1BA9CF;
}
.ZykFZhx0BG.L5yVZirEgD {
  background: #d27c02;
}
.ZykFZhx0BG.uHk9eMZSCf {
  background: #fb9402;
}
.ZykFZhx0BG.QL1LqkYi7H {
  background: #FD9B30;
}
.ZykFZhx0BG.M8FJixR2PY {
  background: #FDBE2D;
}
.ZykFZhx0BG.OUjHBdDnwf {
  background: #FED831;
}
.ZykFZhx0BG.W7oJ_gqpWj {
  background: #FFFD38;
}
.ZykFZhx0BG.H1ZCh7wKEi {
  background: #2D215C;
}
.ZykFZhx0BG.oV5yiQz6Ki {
  background: #483C83;
}
.ZykFZhx0BG.IVbsIvU1Sz {
  background: #58518d;
}
.ZykFZhx0BG.cxZrLxauu5 {
  background: #7068A9;
}
.ZykFZhx0BG.a4mZd7OTMW {
  background: #7f78b2;
}
.ZykFZhx0BG.V9tIFK1p1E {
  background: #8f88bc;
}
.ZykFZhx0BG.LI7h9FZrtU {
  background: #000;
}
.ZykFZhx0BG.Yu1nR0hu7E {
  background: #282626;
}
.ZykFZhx0BG.xRqzU3wkfy {
  background: #242222;
}
.ZykFZhx0BG.W73eaNxldk {
  background: #353838;
}
.ZykFZhx0BG.mPVtKeNPRI {
  background: #666;
}
.ZykFZhx0BG.CywcCUyB0n {
  background: #999;
}
.ve1vOl6h03 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.ve1vOl6h03 .Tzlcj3sMMt {
  display: none;
}
.EUZP5Jj9lu {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-end;
  height: 16px;
}
.EUZP5Jj9lu h3 {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 0;
  margin-right: 8px;
}
.EUZP5Jj9lu .R2JFxa1yKL {
  height: auto;
  margin-left: 12px;
}
._9_dz6NWGl {
  padding: 10px;
  font-size: 12px;
  background-color: #f5f6fa;
  padding: 16px 12px;
  word-wrap: break-word;
}
._9_dz6NWGl.vN3jMsM5Yw {
  background-color: #fdf8ea;
  padding: 8px 0 32px 12px;
}
._9_dz6NWGl.vN3jMsM5Yw[contenteditable="true"] {
  font-size: 12px;
  outline: 0px solid transparent;
  border: 1px solid #f6c345;
}
.ATv4BJzP4j {
  display: flex;
  justify-content: right;
}
.ATv4BJzP4j .A9qhvi3ejm {
  font-size: 12px;
}
.ATv4BJzP4j .A9qhvi3ejm.dPQE64HU1u {
  background-color: #e5e5e5;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `GZwcJSPkZS`,
	"color-row": `F8cMSZaC7p`,
	"color-tile": `ZykFZhx0BG`,
	"picker-component": `hybQZy90Wv`,
	"picker-element": `rGbWH2fthO`,
	"active": `DP7dv9E_vW`,
	"btn": `bB7hFy_HVF`,
	"red-1": `SCCsst51cE`,
	"red-2": `ByPutRaigN`,
	"red-3": `dATjqRTqTQ`,
	"red-4": `o5XF8xZfrb`,
	"red-5": `TLQ2LrOHDd`,
	"red-6": `_HZvGH1XXG`,
	"orange-1": `iCHRQUasnb`,
	"orange-2": `nyZho1lqBK`,
	"orange-3": `B4XI3q4ceL`,
	"orange-4": `znOpVld2xF`,
	"orange-5": `Tswy3wC_e3`,
	"orange-6": `bSrji2HybU`,
	"green-1": `W6CFYNxqlG`,
	"green-2": `GlVawwCAp2`,
	"green-3": `cfa2aajBqR`,
	"green-4": `cBMs2VEJWr`,
	"green-5": `IIeGOvNzin`,
	"green-6": `qFmvWjx6WX`,
	"blue-1": `mxxP_gI5Tc`,
	"blue-2": `RMTMgWc9uD`,
	"blue-3": `lSt6QqbkE_`,
	"blue-4": `pB7QaRs0Wk`,
	"blue-5": `R5pCYCZMBN`,
	"blue-6": `a3POoOlBJU`,
	"yellow-1": `L5yVZirEgD`,
	"yellow-2": `uHk9eMZSCf`,
	"yellow-3": `QL1LqkYi7H`,
	"yellow-4": `M8FJixR2PY`,
	"yellow-5": `OUjHBdDnwf`,
	"yellow-6": `W7oJ_gqpWj`,
	"purple-1": `H1ZCh7wKEi`,
	"purple-2": `oV5yiQz6Ki`,
	"purple-3": `IVbsIvU1Sz`,
	"purple-4": `cxZrLxauu5`,
	"purple-5": `a4mZd7OTMW`,
	"purple-6": `V9tIFK1p1E`,
	"black-1": `LI7h9FZrtU`,
	"black-2": `Yu1nR0hu7E`,
	"black-3": `xRqzU3wkfy`,
	"black-4": `W73eaNxldk`,
	"black-5": `mPVtKeNPRI`,
	"black-6": `CywcCUyB0n`,
	"picker-theme": `ve1vOl6h03`,
	"arrow-regular": `Tzlcj3sMMt`,
	"instructionHeader": `EUZP5Jj9lu`,
	"instructionHeader__btn": `R2JFxa1yKL`,
	"instructionContent": `_9_dz6NWGl`,
	"instructionContentEdit": `vN3jMsM5Yw`,
	"instructionFooter": `ATv4BJzP4j`,
	"button": `A9qhvi3ejm`,
	"cancelButton": `dPQE64HU1u`
};
export default ___CSS_LOADER_EXPORT___;
